import { EdGroup } from "../../EdGroup";

export const GroupFieldName = {
  name: "name",
  groupType: "groupType",
  description: "description",
  attributeId: "attributeId",
  translations: "translations",
} satisfies Partial<Record<keyof EdGroup, keyof EdGroup>>;
